import { useNavigate } from 'react-router'

import { Container, Section } from 'components'
import { useMappedTranslation, usePageTitle } from 'hooks'
import { Button } from 'oneui'

export function TemporaryIdExpiredError() {
  const t = useMappedTranslation()
  const navigate = useNavigate()

  usePageTitle(t('iam.01.Common.Title.Account.already.created.with.that.link'))

  const handleDone = () => {
    navigate(-1)
  }

  return (
    <Container size='small'>
      <Section
        title={t('iam.01.Common.Title.Account.already.created.with.that.link')}
        titleSx={{
          fontSize: { xs: '24px', md: '32px' },
          fontWeight: { xs: '500', md: '300' },
          mt: { xs: '0px', md: '30px' }
        }}
        articleSx={{
          padding: {
            xs: '30px 24px',
            md: '48px 96px',
            lg: '48px 72px'
          }
        }}
        actionsSx={{
          '&:not(:first-of-type)': { marginTop: { xs: '0px', md: '0px' } }
        }}
        description={t('iam.01.Common.Txt.That.link.was.already.used.to.create.a.Samsung.account.Sign.in.to.the.account')}
        descriptionSx={{
          fontSize: '16px',
          fontWeight: '500',
          mt: { xs: '0px', md: '30px' }
        }}
        actions={
          <Button sx={{ marginTop: { xs: '20px', md: '72px' } }} onClick={handleDone} data-testid='Button149C03D3'>
            {t('iam.01.Common.Button.OKAY')}
          </Button>
        }
      />
    </Container>
  )
}
